import React from 'react'
import { Box } from '@mui/joy'

const CellNameAndColor = ({ value, colorField}) => {
	return (
		<Box className={'list-element-cell cell-color cell-name-and-color' }>
			<span className="color-dot" style={{ backgroundColor: colorField }}></span>
			<span className="name">{value}</span>
		</Box>
	)
}

export default CellNameAndColor